import initConcessionCalculatorFlow from './flow';
import { ConcessionCalculatorGoogleAnalytics4, pagePath } from './analytics';

/* eslint-disable no-param-reassign */

function runWhenReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
    return;
  }

  callback();
}

export default function initConcessionCalculatorV2(pageTitle) {
  const ga4 = new ConcessionCalculatorGoogleAnalytics4(pageTitle);

  runWhenReady(() => {
    const form = document.getElementById('concession-calculator-form');
    const flow = initConcessionCalculatorFlow(form);
    const submitButton = document.getElementById('concession-calculator-submit');
    const submitSpinner = document.getElementById('concession-calculator-save-spinner');
    const submitText = document.getElementById('concession-calculator-submit-text');

    if (form) {
      ga4.pageView(pagePath.form);

      form.addEventListener('submit', () => {
        flow.prepareHiddenStepsForSubmit();
        ga4.event('check_eligibility_clicked', {}, pagePath.form);

        if (submitSpinner) submitSpinner.classList.remove('at-d-none');
        if (submitText) submitText.textContent = 'Checking eligibility';

        requestAnimationFrame(() => {
          form.querySelectorAll('fieldset').forEach((fieldset) => {
            fieldset.disabled = true;
          });
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.style.background = '#444E61';
            submitButton.style.color = '#FFFFFF';
          }
        });
      });
    }
  });
}
